angular.module("leanlaw").controller("ReferralModalController", ["$scope", "close", "setting", "userService", "alerts", function ($scope, close, setting, userService, alerts) {
  $scope.setting = angular.copy(setting);
  $scope.setting.referrals = $scope.setting.referrals || [];
  const missing = 5 - $scope.setting.referrals.length;
  for (let i = 0; i < missing; i++) {
    $scope.setting.referrals.push({});
  }
  userService.list().then(accounts => {
    $scope.accounts = accounts.filter(a => a.id !== $scope.setting.account.id);
    $scope.setting.referrals.forEach(r => {
      r.account = $scope.accounts.find(a => a.id === r.id);
    });
  });
  $scope.confirm = function () {
    if ($scope.setting.referrals.find(r => r.referral < 0 || r.referral > 100)) {
      alerts.error("Referral percentage must be between 0 and 100");
      return;
    }
    $scope.setting.referrals = $scope.setting.referrals.filter(r => r.account && r.referral).map(r => ({
      id: r.account.id,
      referral: r.referral
    }));
    close($scope.setting);
  };
  $scope.reject = function () {
    close(false);
  };
}]);